import logo from "./images/logo.svg";
import restaurant1 from "./images/restaurant1.jpg";
import restaurant2 from "./images/restaurant2.jpg";
import restaurant3 from "./images/restaurant3.jpg";

export { logo, restaurant1, restaurant2, restaurant3 };
